// @core/api/endpoints/workflow/get_product_manifest.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetProductManifestResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Get product manifest
 * Returns the currently registered manifest for a product: events, node types, and templates.
 */
export async function GetProductManifest(
  product_slug: string,
  options?: RequestOptions
): Promise<GetProductManifestResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/product-registry/:product_slug`;
  requestPath = requestPath.replace(':product_slug', encodeURIComponent(product_slug));
  const requestOptions = options;
  return client.get<GetProductManifestResponse>(requestPath, { ...requestOptions });
}
